export const techStacks = [
    {
        name: "Programming Languages",
        category: "languages",
        list: [
            "JavaScript",
            "TypeScript",
            "Java",
            "Python",
            "C#",
            "C++",
            "Dart",
        ]
    },
    {
        name: "Web Frameworks & Libraries",
        category: "frameworks",
        list: [
            "React",
            "Next.js",
            "Node.js",
            "Express",
            "Bootstrap",
            "Tailwind",
            ".NET",
            "Flutter",
        ]
    },
    {
        name: "Databases",
        category: "databases",
        list: [
            "Supabase",
            "PostgreSQL",
            "MongoDB",
            "Firebase",
            "MySQL"
        ]
    },
    {
        name: "Tools & Platforms",
        category: "tools",
        list: [
            "Git",
            "Figma",
        ]
    },
]